"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReCaptchaWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.ReCaptchaWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    px: '5px',
    mb: [null, '20px'],
}));
//# sourceMappingURL=fdr-catalogs-order-recaptcha.styles.js.map